import Home from '@atlassian/mpac-home';
import React from 'react';
import { Redirect } from 'react-router-dom';

import type { RouteComponentProps } from 'react-router-dom';

const productHomePageRedirectionMap = {
  jira: 'jira',
  confluence: 'confluence',
  'jira-service-management': 'jira-service-management',
  bitbucket: 'bitbucket',
  compass: 'compass',
  'fisheye-crucible': 'fisheye',
  bamboo: 'bamboo',
  crowd: 'crowd',
} as const;

type TParams = {
  app?: 'app' | 'cloud-fortified';
  appId?: string;
  productId?: string;
};

const AddonHomePageRouteProcessor = (props: RouteComponentProps<TParams>) => {
  const {
    match: { params },
  } = props;

  if (params.app === 'app' && params.appId && productHomePageRedirectionMap[params.appId]) {
    return <Redirect to={`/product/${productHomePageRedirectionMap[params.appId]}`} />;
  }

  if (params.app === 'app') {
    return <Redirect to="/" />;
  }

  if (params.app === 'cloud-fortified') {
    return <Redirect to="/search?trustSignals=cloudFortified" />;
  }

  return <Home productId={params.productId} />;
};

export default AddonHomePageRouteProcessor;
